import { FC, useState } from 'react';
import { FormBehavior, observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { removeMaskCpfOrCnpj, showAlert, useStores } from '~/utils';
import AuditSearch from './AuditSearch';
import { validationSchema } from './schema';

const AuditSearchContainer: FC = () => {
  const { audit } = useStores();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleFormSubmit = async ({ document }: { document: string }) => {
    try {
      setLoading(true);
      await audit.getClientAccount(removeMaskCpfOrCnpj(document));
      navigate(Routes.AUDIT);
    } catch ({ message }) {
      showAlert({ message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormBehavior
      validationSchema={validationSchema}
      initialValues={{ document: '' }}
      onSubmit={handleFormSubmit}
      enableReinitialize
    >
      <AuditSearch isSubmitting={loading} />
    </FormBehavior>
  );
};

export default observer(AuditSearchContainer);
